import {
  VitalsTemplate,
  type VitalsTemplateGroup,
  type VitalsTemplateRow,
} from '../../templates';
import { DocumentSource, DocumentType } from '../types';
import type { DocumentEntry, DocumentKey } from '../types';
import { getProviderFacilityPdfEntry } from './pdfOverride';
import type { RawSourceMetadata } from './_shared';

type VitalsDataKey = Extract<
  DocumentKey,
  { source: DocumentSource.MEDICAL_DATA; type: DocumentType.VITALS }
>;

interface RawVital extends VitalsTemplateRow {
  vitalSignId?: string;
  observationCode?: string;
  observationCodeSystem?: string;
  sourceMetadata?: RawSourceMetadata;
  patientId?: string;
  observationCategory?: string;
  vitalSignCodes?: string[];
  observationName?: string;
  observationText?: string;
  observationDatetime?: string;
  observationUnit?: string;
  observationValue?: string;
}

export interface VitalsDataQueryData {
  groupingObservationId?: string;
  vitals?: RawVital[];
}

export const adaptVitalsData = (
  data: VitalsDataQueryData,
  key: VitalsDataKey,
): DocumentEntry | undefined => {
  if (!data) return undefined;

  const vitals = data.vitals ?? [];

  const pdf = getProviderFacilityPdfEntry(key.sourceType, vitals, {
    title: key.name,
  });
  if (pdf) return pdf;

  const groups: VitalsTemplateGroup[] = [
    {
      id: data.groupingObservationId,
      observedAt: vitals[0]?.observedAt,
      vitals,
    },
  ];

  return {
    kind: 'template',
    title: key.name,
    highlightAnchorId: `vital-${key.vitalId}`,
    render: (ctx) => (
      <VitalsTemplate
        groups={groups}
        patient={ctx?.patient}
        filename={ctx?.filename}
        generatedAt={new Date()}
        highlightVitalId={key.vitalId}
      />
    ),
  };
};
